module.exports = __webpack_public_path__ + "img/appstore.3b20d739.png";